export default __webpack_public_path__ + "static/media/sha256_semcasting_id.945e24e9.csv";